module.exports = __webpack_public_path__ + "img/francesco-marzullo.6f4ae73d.svg";